import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode:"history",
  routes: [
    // {
    //   path: '/:code',
    //   name: 'PayPayComponent',
    //   component: ()=>import("@/components/demo/PayPayComponent"),
    //   props: true
    // },
    {
      path: '/nRBsMw',
      name: 'PayPayComponent',
      component: ()=>import("@/components/demo/PayPayComponent"),
      props: true
    },


    {
      path: '*',//错误页面
      name: 'error',
      component: ()=>import("@/components/admin/Page404")
    },
    {
      path: '/page404',//错误页面
      name: 'error',
      component: ()=>import("@/components/admin/Page404")
    },



/*-----------------------------分割线---------------------------------------*/


  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js